import Blue from "~/core";

new Blue({
  name: 'Testimonials',
  selector: ".testimonial-list",
  setup(testimonials) {
    const navClick = document.querySelectorAll('.testimonial__nav-item');
    const testimonialListItems = testimonials.querySelectorAll('.testimonial__item');
    testimonialListItems[0].classList.add('is-active');

		let largestHeight = 0;
		let hiddenContentContainers;
		let currentContentWidth;

    if(testimonialListItems.length == 2){
      testimonialListItems[1].classList.add('is-visible');
    }
    else if(testimonialListItems.length > 2){
      testimonialListItems[1].classList.add('is-visible');
      testimonialListItems[2].classList.add('is-visible');
    }

		const adjustSlideHeight = () => {
			largestHeight = 0;
			testimonialListItems.forEach(t => t.style.height = "");
			testimonialListItems.forEach(t => t.querySelector(".testimonial__content").style.minHeight = "");
			testimonialListItems.forEach(t => t.querySelector(".testimonial__content").style.width = "");
			
			// Set width of content containers in the .is-visible slides to calculate their height appropriately
			hiddenContentContainers = [...testimonials.querySelectorAll(".testimonial__item.is-visible .testimonial__content")];
			currentContentWidth = testimonials.querySelector(".testimonial__item.is-active .testimonial__content").offsetWidth;
			hiddenContentContainers.forEach(div => {
				div.style.width = currentContentWidth + "px";
			});

			// Get padding and margin values from the content element (should all be the same, so just use the first one)
			// then use these values to add in needed extra space for the height value
			let contentComputedStyles = window.getComputedStyle(testimonialListItems[0].querySelector(".testimonial__content"));
			let paddingTop = parseFloat(contentComputedStyles.paddingTop.split("px")[0]);
			let paddingBottom = parseFloat(contentComputedStyles.paddingBottom.split("px")[0]);
			let marginTop = parseFloat(contentComputedStyles.marginTop.split("px")[0]);

			testimonialListItems.forEach(t => {
				let quote = t.querySelector(".testimonial__quote");
				let name = t.querySelector(".testimonial__name-container");
				largestHeight = Math.max(largestHeight, name.getBoundingClientRect().bottom - quote.getBoundingClientRect().top);
			});

			// If desktop, set the height of the whole slide, 
			// otherwise set the min-height of the content element only, 
			// since it will be stacked vertically under the image
			if (this.$screen.lg.matches) {
				testimonialListItems.forEach(t => t.style.height = `${largestHeight + paddingTop + paddingBottom + marginTop}px`);
			} else {
				testimonialListItems.forEach(t => t.querySelector(".testimonial__content").style.minHeight = `${largestHeight + paddingTop + paddingBottom + marginTop}px`);
			}
		}

		adjustSlideHeight();
		
		// Below used to throttle resize event to prevent adjustSlideHeight() from 
		// running many times per second during resize and causing lag
		let resizing = false;
		setInterval(() => {
			if (resizing) {
				resizing = false;
				adjustSlideHeight();
			}
		}, 500);
		this.$addEvents(window, "resize", () => {resizing = true});

    navClick.forEach(element => {
      this.$addEvents(element, 'click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation()
        let testimonialItems = testimonials.querySelectorAll('.testimonial__item')
        let testimonialLength = testimonialItems.length;
        let isActive = testimonials.querySelector('.is-active');
        let isActiveIndex = Array.from(isActive.parentElement.children).indexOf(isActive);
        if(event.currentTarget.classList.contains("testimonial__nav-item--forward")){
          removeIsVisible();
          testimonialItems[isActiveIndex].classList.remove('is-active');
          let movedIndex = checkValues((isActiveIndex + 1), testimonialLength);
          testimonialItems[movedIndex].classList.add('is-active');
          let nextItem = checkValues((isActiveIndex + 2), testimonialLength);
          testimonialItems[nextItem].classList.remove('is-active');
          testimonialItems[nextItem].classList.add('is-visible');
          if(testimonialListItems.length > 2){
            let nextNextItem = checkValues((isActiveIndex + 3), testimonialLength);
            testimonialItems[nextNextItem].classList.add('is-visible');
          }
        }
        else if(event.currentTarget.classList.contains("testimonial__nav-item--backward")) {
          removeIsVisible();
          let movedIndex = checkValues((isActiveIndex - 1), testimonialLength);
          testimonialItems[movedIndex].classList.add('is-active');
          let nextItem = checkValues((isActiveIndex), testimonialLength);
          testimonialItems[nextItem].classList.remove('is-active');
          testimonialItems[nextItem].classList.add('is-visible');
          if(testimonialListItems.length > 2){
            let nextNextItem = checkValues((isActiveIndex + 1), testimonialLength);
            testimonialItems[nextNextItem].classList.add('is-visible');
          }
        }
      })
    });
    const removeIsVisible = () => {
      const visItems = testimonials.querySelectorAll('.is-visible');
      visItems.forEach(element => {
        element.classList.remove('is-visible');
      });
    }
    function checkValues(indexVal, ArrayCount){
      if(indexVal < 0){
        return ArrayCount - 1;
      }
      else if (indexVal > ArrayCount - 1 ){
        return indexVal - ArrayCount;
      }
      else{
        return indexVal;
      }
    } 
  }
});